import { api } from '@/core/helpers/axiosHelper';

export default {
   async delete(tag_typeable_id: number) {
      return await api.delete('/tag-typeable/' + tag_typeable_id).then((response) => {
         return response.data;
      });
   },
};
